<div class="ws-page ws-page-spacious">

  <header class="page-head">

    <div>

      <p class="kicker">Compliance · Bye-law norms</p>

      <div class="page-head-title-row">
        <app-page-back-btn />
        <h2>Bye-law norms</h2>
      </div>

      <p class="muted ws-lead">UP Model Building Byelaws 2025 — Section 3.2, one row per source clause</p>

    </div>

    <div class="actions">

      <button type="button" class="btn primary" *ngIf="session.canAccessConfig()" (click)="openCreate()">+ Add norm</button>

    </div>

  </header>



  <p class="error" *ngIf="error()">{{ error() }}</p>



  <section class="page-card page-card--compact-head">

    <div class="bl-toolbar">

      <input

        class="bl-search"

        [(ngModel)]="search"

        placeholder="Search norm type, category, sub-type…"

        (ngModelChange)="onSearchChange()"

        (keyup.enter)="onFilterChange()"

      />

      <select class="bl-select" [(ngModel)]="normTypeFilter" (change)="onFilterChange()">

        <option *ngFor="let t of normTypeFilters" [value]="t.value">{{ t.label }}</option>

      </select>

      <select class="bl-select" [(ngModel)]="categoryFilter" (change)="onFilterChange()">

        <option value="">All categories</option>

        <option *ngFor="let c of categories()" [value]="c.code">{{ c.name }}</option>

      </select>

      <span class="bl-count" *ngIf="!loading()">{{ rangeLabel() }}</span>

    </div>



    <p class="ws-loading" *ngIf="loading()">Loading bye-law norms…</p>

    <p class="ws-empty" *ngIf="!loading() && !rows().length">No bye-law norms match filters.</p>



    <div class="bl-table-wrap" *ngIf="!loading() && rows().length">

      <table class="bl-table">

        <thead>

          <tr>

            <th>Norm type</th>

            <th>Category</th>

            <th>Sub-type</th>

            <th>Plot area (sq.m)</th>

            <th>Road width (m)</th>

            <th>Coverage (%)</th>

            <th>Base FAR</th>

            <th>Max FAR</th>

            <th>Height max (m)</th>

            <th>Front SB</th>

            <th>Rear SB</th>

            <th>Side-1 SB</th>

            <th>Side-2 SB</th>

            <th>Clause</th>

            <th *ngIf="session.canAccessConfig()"></th>

          </tr>

        </thead>

        <tbody>

          <tr *ngFor="let r of rows()" [class.bl-row-clickable]="session.canAccessConfig()" (click)="session.canAccessConfig() && openEdit(r)">

            <td>

              <span class="bl-norm-pill" [ngClass]="normTypeClass(r)">{{ normTypeLabel(r) }}</span>

            </td>

            <td>{{ r.categoryName || r.categoryCode || '—' }}</td>

            <td><strong class="text-primary">{{ r.useTypeName || r.useTypeCode }}</strong></td>

            <td class="num" [class.dash]="formatPlotRange(r) === '—'">{{ formatPlotRange(r) }}</td>

            <td class="num" [class.dash]="formatRoadRange(r) === '—'">{{ formatRoadRange(r) }}</td>

            <td class="num" [class.dash]="formatCell(r.groundCoveragePct) === '—'">{{ formatCell(r.groundCoveragePct) }}</td>

            <td class="num" [class.dash]="formatCell(r.farBase) === '—'">{{ formatCell(r.farBase) }}</td>

            <td class="num" [class.dash]="formatCell(r.farMax) === '—'">{{ formatCell(r.farMax) }}</td>

            <td class="num" [class.dash]="formatHeight(r) === '—'">{{ formatHeight(r) }}</td>

            <td class="num" [class.dash]="formatCell(r.setbackFront) === '—'">{{ formatCell(r.setbackFront) }}</td>

            <td class="num" [class.dash]="formatCell(r.setbackRear) === '—'">{{ formatCell(r.setbackRear) }}</td>

            <td class="num" [class.dash]="formatCell(r.setbackSide1) === '—'">{{ formatCell(r.setbackSide1) }}</td>

            <td class="num" [class.dash]="formatCell(r.setbackSide2) === '—'">{{ formatCell(r.setbackSide2) }}</td>

            <td class="text-meta">{{ r.clauseRef }}</td>

            <td *ngIf="session.canAccessConfig()">

              <button type="button" class="bl-link-danger" (click)="deactivate(r, $event)">Delete</button>

            </td>

          </tr>

        </tbody>

      </table>

    </div>

    <div class="pager" *ngIf="!loading() && total() > 0">
      <span class="pager-meta">Page {{ page() }} / {{ totalPages() }}</span>
      <div class="actions">
        <button type="button" class="btn secondary" [disabled]="page() <= 1" (click)="goFirst()">First</button>
        <button type="button" class="btn secondary" [disabled]="page() <= 1" (click)="goPrev()">Previous</button>
        <button type="button" class="btn secondary" [disabled]="page() >= totalPages()" (click)="goNext()">Next</button>
        <button type="button" class="btn secondary" [disabled]="page() >= totalPages()" (click)="goLast()">Last</button>
      </div>
    </div>

  </section>

</div>



<!-- Modal: Mam wireframe -->

<div class="bl-modal-backdrop" *ngIf="modalOpen()" (click)="closeModal()" role="dialog" aria-modal="true">

  <div class="bl-modal" (click)="$event.stopPropagation()">

    <div class="bl-modal-head">

      <div>

        <h3>{{ editingId() ? 'Edit bye-law norm' : 'Add bye-law norm' }}</h3>

        <p>Pick the norm type — only the fields that clause uses appear below.</p>

      </div>

      <button type="button" class="bl-modal-close" (click)="closeModal()" aria-label="Close">×</button>

    </div>



    <div class="bl-norm-tabs">

      <button

        type="button"

        class="bl-norm-tab"

        *ngFor="let t of normTabs"

        [class.active]="form.normTab === t.id"

        (click)="setNormTab(t.id)"

      >

        {{ t.label }}

      </button>

    </div>



    <div class="bl-modal-body">

      <p class="bl-section-title">Classification</p>

      <div class="form-grid">

        <label>

          Category

          <select [(ngModel)]="form.categoryId" (ngModelChange)="onCategoryChange()">

            <option value="">Select category</option>

            <option *ngFor="let c of categories()" [value]="c.id">{{ c.name }}</option>

          </select>

        </label>

        <label>

          Sub-type

          <select [(ngModel)]="form.useTypeId" [disabled]="!form.categoryId">

            <option value="">{{ form.categoryId ? 'Select sub-type' : 'Select category first' }}</option>

            <option *ngFor="let s of filteredSubtypesForForm()" [value]="s.id">{{ s.name }}</option>

          </select>

        </label>

      </div>



      <ng-container [ngSwitch]="form.normTab">

        <ng-container *ngSwitchCase="'PLOT_SIZE'">

          <p class="bl-section-title">Plot area and road width</p>

          <div class="form-grid">

            <label>Plot area min (sq.m) <input [(ngModel)]="form.plotAreaMin" type="number" /></label>

            <label>Plot area max (sq.m) <input [(ngModel)]="form.plotAreaMax" type="number" /></label>

            <label>Road width min (m) <input [(ngModel)]="form.roadWidthMin" type="number" step="0.01" /></label>

            <label>Road width max (m) <input [(ngModel)]="form.roadWidthMax" type="number" step="0.01" /></label>

          </div>

        </ng-container>



        <ng-container *ngSwitchCase="'FAR'">

          <p class="bl-section-title">FAR and ground coverage</p>

          <div class="form-grid">

            <label>Ground coverage (%) <input [(ngModel)]="form.groundCoveragePct" type="number" step="0.01" /></label>

            <label>Base FAR <input [(ngModel)]="form.farBase" type="number" step="0.01" /></label>

            <label>Max FAR <input [(ngModel)]="form.farMax" type="number" step="0.01" /></label>

            <label>Plot area min (sq.m) <input [(ngModel)]="form.plotAreaMin" type="number" /></label>

            <label>Plot area max (sq.m) <input [(ngModel)]="form.plotAreaMax" type="number" /></label>

            <label>Road width min (m) <input [(ngModel)]="form.roadWidthMin" type="number" step="0.01" /></label>

            <label>Road width max (m) <input [(ngModel)]="form.roadWidthMax" type="number" step="0.01" /></label>

          </div>

        </ng-container>



        <ng-container *ngSwitchCase="'HEIGHT'">

          <p class="bl-section-title">Height limit</p>

          <div class="form-grid">

            <label>Height max (m) <input [(ngModel)]="form.heightMax" type="number" step="0.01" /></label>

            <label class="bl-span-2">Remarks (e.g. No restriction) <input [(ngModel)]="form.remarks" /></label>

          </div>

        </ng-container>



        <ng-container *ngSwitchCase="'SETBACK'">

          <p class="bl-section-title">Setbacks (metres)</p>

          <div class="form-grid">

            <label>Front <input [(ngModel)]="form.setbackFront" type="number" step="0.01" /></label>

            <label>Rear <input [(ngModel)]="form.setbackRear" type="number" step="0.01" /></label>

            <label>Side 1 <input [(ngModel)]="form.setbackSide1" type="number" step="0.01" /></label>

            <label>Side 2 <input [(ngModel)]="form.setbackSide2" type="number" step="0.01" /></label>

            <label>Plot area min (sq.m) <input [(ngModel)]="form.plotAreaMin" type="number" /></label>

            <label>Plot area max (sq.m) <input [(ngModel)]="form.plotAreaMax" type="number" /></label>

          </div>

        </ng-container>



        <ng-container *ngSwitchCase="'ELECTRIC'">

          <p class="bl-section-title">Electric line clearance (attributes)</p>

          <div class="form-grid">

            <label>Front SB <input [(ngModel)]="form.setbackFront" type="number" step="0.01" /></label>

            <label>Rear SB <input [(ngModel)]="form.setbackRear" type="number" step="0.01" /></label>

            <label>Side 1 SB <input [(ngModel)]="form.setbackSide1" type="number" step="0.01" /></label>

            <label class="bl-span-2">

              Attributes (JSON)

              <textarea [(ngModel)]="form.attributesJson" rows="3" placeholder='{"HEIGHT_BAND":"ABOVE_15M"}'></textarea>

            </label>

          </div>

        </ng-container>

      </ng-container>



      <p class="bl-section-title">Source and validity</p>

      <div class="form-grid">

        <label>Clause reference <input [(ngModel)]="form.clauseRef" placeholder="e.g. 3.2.4.1" /></label>

        <label>Effective from <input [(ngModel)]="form.effectiveFrom" type="date" /></label>

        <label class="bl-span-2">

          Remarks

          <textarea [(ngModel)]="form.remarks" rows="2" placeholder="Optional — notes, exemptions, height band"></textarea>

        </label>

      </div>

    </div>



    <div class="bl-modal-foot">

      <button type="button" class="btn secondary" (click)="closeModal()" [disabled]="saving()">Cancel</button>

      <button type="button" class="btn primary" (click)="save()" [disabled]="saving()">

        {{ saving() ? 'Saving…' : 'Save norm' }}

      </button>

    </div>

  </div>

</div>



<div class="toast" *ngIf="toast()">{{ toast() }}</div>


